import _cloneDeep from 'lodash/cloneDeep'
import _has from 'lodash/has'
import ACTIONS from '../actions.js'

export function emailReducer(state, action) {
  switch (action.type) {
    case ACTIONS.ADD_RECIPIENT:
      return { ...state, recipients: [...state.recipients, { email: '' }] }

    case ACTIONS.REMOVE_RECIPIENT: {
      const newRecipients = _cloneDeep(state.recipients)
      if (newRecipients && newRecipients.length > 1) {
        delete newRecipients[action.index]
        return {
          ...state,
          recipients: newRecipients.filter(item => _has(item, 'email')),
        }
      }
      return state
    }

    case ACTIONS.UPDATE_RECIPIENT: {
      const newRecipients = [...state.recipients]
      newRecipients[action.index] = {
        ...newRecipients[action.index],
        ...action.value,
      }
      return { ...state, recipients: newRecipients }
    }

    case ACTIONS.ADD_RECEIVER:
      return { ...state, receivers: [...state.receivers, { email: '' }] }

    case ACTIONS.REMOVE_RECEIVER: {
      const newReceivers = _cloneDeep(state.receivers)
      if (newReceivers && newReceivers.length > 1) {
        delete newReceivers[action.index]
        return {
          ...state,
          receivers: newReceivers.filter(item => _has(item, 'email')),
        }
      }
      return state
    }

    case ACTIONS.UPDATE_RECEIVER: {
      const newReceivers = [...state.receivers]
      newReceivers[action.index] = {
        ...newReceivers[action.index],
        ...action.value,
      }
      return { ...state, receivers: newReceivers }
    }

    case ACTIONS.TOGGLE_SEND_EMAILS:
      return {
        ...state,
        sendEmails: action.value,
        recipients: action.value ? [{ email: '' }] : [],
        emailMessage: action.value ? state.emailMessage : '',
      }

    case ACTIONS.TOGGLE_RECEIVE_EMAILS:
      return {
        ...state,
        receiveEmails: action.value,
        receivers: action.value ? [{ email: '' }] : [],
      }

    case ACTIONS.SET_EMAIL_RESULTS:
      return { ...state, emailResults: action.value }

    default:
      return state
  }
}

export default emailReducer
